/**
 * Origin only — no path, query, or hash. Use this for every page URL we send
 * to a vendor (CAPI event_source_url, VWO page.url, marketing currentUrl).
 * Full href leaks survey steps like `/survey/sex`. Browser SDKs may still
 * scrape `window.location` on their own.
 *
 * Kept in a dependency-light file so CAPI callers can import it without
 * pulling the pixel retry / error stack.
 */
export function getPixelEventSourceUrl(): string {
  return window.location.origin;
}
